import * as Yup from "yup";

export function initialValues() {
  return {
    subjectId: "",
    gradeId: "",
  };
}

export function validationSchema() {
  return Yup.object({
    subjectId: Yup.string().required("La asignatura es obligatoria").nullable(),
    gradeId: Yup.string().required("El grado es obligatorio"),
  });
}
